import { NavLink, useLocation } from 'react-router-dom'

import { isActivePath, sectionOf, type NavTree } from '@/app/registry'
import { useLogout } from '@/api/useLogout'
import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

import { BrandMark } from './BrandMark'

/** Боковое меню десктопа (от 1024 px). */
export function Sidebar({ nav, className }: { nav: NavTree; className?: string }) {
  const { pathname } = useLocation()
  const section = sectionOf(pathname, nav)
  const logout = useLogout()

  return (
    <aside
      className={cn(
        'sticky top-0 h-dvh w-60 shrink-0 flex-col border-r border-border bg-surface px-3 py-4',
        className,
      )}
    >
      <div className="mb-5 flex items-center gap-2.5 px-2.5">
        <BrandMark />
        <span className="text-[15px] font-semibold tracking-tight text-fg">Telos</span>
      </div>
      <nav aria-label="Главное меню" className="min-h-0 flex-1 overflow-y-auto">
        <ul className="flex flex-col gap-0.5">
          {nav.top.map((item) => {
            const active = isActivePath(item.path, pathname)
            const children = nav.children[item.path] ?? []
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  className={cn(
                    'flex min-h-9 items-center gap-3 rounded-lg px-2.5 text-sm font-medium transition-colors',
                    active ? 'bg-accent-soft text-accent' : 'text-muted hover:bg-surface-2 hover:text-fg',
                  )}
                >
                  <Icon name={item.icon} size={18} />
                  <span className="truncate">{item.label}</span>
                </NavLink>
                {children.length > 0 && section === item.path ? (
                  <ul className="mb-1 ml-[1.375rem] mt-0.5 flex flex-col border-l border-border pl-2">
                    {children.map((child) => (
                      <li key={child.path}>
                        <NavLink
                          to={child.path}
                          className={({ isActive }) =>
                            cn(
                              'flex min-h-8 items-center rounded-md px-2.5 text-sm transition-colors',
                              isActive ? 'font-medium text-fg' : 'text-muted hover:text-fg',
                            )
                          }
                        >
                          {child.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            )
          })}
        </ul>
      </nav>
      <button
        type="button"
        onClick={() => logout.mutate()}
        disabled={logout.isPending}
        className="mt-3 flex min-h-9 items-center gap-3 rounded-lg px-2.5 text-sm font-medium text-muted hover:bg-surface-2 hover:text-fg"
      >
        <Icon name="logout" size={18} />
        Выйти
      </button>
    </aside>
  )
}
